/**
 * Self-contained build-time feature flag for Login L4 -- passwordless email
 * magic-link (LOGIN-FEATURE-PROJECT.md L4).
 *
 * Gates the whole flow together: the "Email me a sign-in link" option on the
 * Login page, the /login/magic-link request-form route, and the
 * /login/magic-link/:token landing route that redeems it.
 *
 * WHY ITS OWN FILE (mirrors segmentCollectFlag.js / accountSwitcherFlag.js):
 * kept local so this can be reviewed / merged / rolled out INDEPENDENTLY of
 * featureFlags.js. Defaults OFF; flipped per environment via
 * REACT_APP_MAGIC_LINK_LOGIN.
 *
 * When OFF, everything is BYTE-IDENTICAL to today: no extra link on Login,
 * neither route is registered (falls through to the catch-all NotFound), and
 * no new network call is issued. The BE endpoints are independently gated
 * (404 while MAGIC_LINK_LOGIN_ENABLED is False on that side too), so the
 * feature is inert end-to-end even if only one side's flag were flipped.
 *
 * Flag-name collision audit: REACT_APP_MAGIC_LINK_LOGIN is a new, unique
 * name -- no existing REACT_APP_* var uses the MAGIC_LINK token.
 *
 * At merge this can be folded into src/constants/featureFlags.js.
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const MAGIC_LINK_LOGIN_ENABLED = truthy(
  process.env.REACT_APP_MAGIC_LINK_LOGIN
);
